import { useCallback } from 'react';
import { LocalStore, useLocalStore } from 'shared/helpers/Store';
import { PricingInsightsResultDTO } from '../../../data/CarrierPayDTO';

export const DUMMY_PRICING_INSIGHTS: PricingInsightsResultDTO = {
  carrier_pay: {
    total_price: 1234,
    price_per_km: 1.23,
    distance: 1234,
    confidence: 90,
  },
  recent_moves: [],
  recent_postings: [],
};

export const MAX_TRIAL_INSIGHTS_COUNT = 3;

export const USED_TRIAL_INSIGHTS_COUNT_KEY = 'used_trial_insights_count';

export function isUserFromSuperDispatch() {
  const searchParams = new URLSearchParams(window.location.search);
  const source = searchParams.get('utm_source');

  return (
    source === 'Web SLB' ||
    source === 'Web CTMS' ||
    source === 'Mobile SLB' ||
    source === 'Web STMS'
  );
}

export function isUserFromSTMS() {
  const searchParams = new URLSearchParams(window.location.search);
  const source = searchParams.get('utm_source');

  return source === 'Web STMS';
}

export function useUnlockUtils() {
  const isLimited = !isUserFromSuperDispatch() || isUserFromSTMS();

  const usedTrialInsightsCount = Math.min(
    MAX_TRIAL_INSIGHTS_COUNT,
    Number(useLocalStore(USED_TRIAL_INSIGHTS_COUNT_KEY, '0')),
  );
  const isLimitReached =
    isLimited && usedTrialInsightsCount >= MAX_TRIAL_INSIGHTS_COUNT;

  const incrementUsedInsightsCount = useCallback(() => {
    if (!isLimited) {
      return;
    }

    LocalStore.set(
      USED_TRIAL_INSIGHTS_COUNT_KEY,
      (usedTrialInsightsCount + 1).toString(),
    );
  }, [usedTrialInsightsCount, isLimited]);

  const forceHitLimit = useCallback(() => {
    if (!isLimited) {
      return;
    }

    LocalStore.set(
      USED_TRIAL_INSIGHTS_COUNT_KEY,
      MAX_TRIAL_INSIGHTS_COUNT.toString(),
    );
  }, [isLimited]);

  return {
    isLimited,
    usedCount: usedTrialInsightsCount,
    usagesLeft: MAX_TRIAL_INSIGHTS_COUNT - usedTrialInsightsCount,
    limit: MAX_TRIAL_INSIGHTS_COUNT,
    isLimitReached,
    incrementUsedInsightsCount,
    forceHitLimit,
  };
}
